import React, { useState } from "react";
import { useDispatch } from "react-redux";
import moment from 'moment';
import 'moment-timezone';
import {
    Flex,
    Heading,
    Button,
    Stack,
    Text,
    Box,
    useColorMode,
    HStack,
    Icon,
    VStack,
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { getPreferences, getAccountValues } from '../store/user/thunks';
import { getTradesStats, getTradesPage } from '../store/trades/thunks';

import '../styles/profile.css';


const AskPaymentCard = ({promptPayment, setPromptPayment}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { colorMode } = useColorMode();

    const [loading, setLoading] = useState(false);

    const handleGoHome = async () => {
        setLoading(true);
        try {
            setPromptPayment(false);
            await dispatch(getTradesStats());
            await dispatch(getPreferences());
            let filters = {};
            const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
            filters.date = moment.utc(new Date().toISOString()).tz(userTZ).format('YYYY-MM-DD');
            await dispatch(getAccountValues({ filters }));
            filters = {};
            filters.page = 1;
            filters.numrows = 5;
            filters.trade_date = 'NULL';
            await dispatch(getTradesPage({ filters }));
            navigate("/");
        } finally {
            setLoading(false);
        }
    };

    const handleGoPay = () => {
        setPromptPayment(!promptPayment);
        navigate("/payment");
    };

    const features = [
        "Unlimited trade logging",
        "Performance analytics",
        "Trading journal",
        "AI-powered insights",
    ];


    return (
        <Flex
            direction="column"
            minH="100vh"
            bg={colorMode === 'light' ? "gray.200" : "gray.800"}
            justifyContent="center"
            alignItems="center"
        >
            <Stack
                flexDir="column"
                mb="2"
                justifyContent="center"
                alignItems="center"
            >
                <Box minW={{ base: "90%", md: "468px" }} rounded="lg" overflow="hidden" boxShadow="2px 4px 4px rgba(0,0,0,0.2)">
                    <Stack
                        spacing={4}
                        p="1rem"
                        backgroundColor={colorMode === 'light' ? "whiteAlpha.900" : "whiteAlpha.100"}
                        boxShadow="md"
                        minW='300px'
                    >
                        <Heading className="page-heading" fontSize="xl" ml={1} mb={-1} color={colorMode === 'light' ? 'gray.600' : 'gray.200'}>
                            Upgrade Account
                        </Heading>

                        <Text fontSize="sm" color={colorMode === 'light' ? 'gray.600' : 'gray.300'}>
                            Unlock full access to MyTradingTracker for a one-time <b>$5</b> payment:
                        </Text>

                        <VStack align="start" spacing={2} pl={2}>
                            {features.map((feature) => (
                                <HStack key={feature} spacing={2}>
                                    <Icon as={CheckIcon} color="green.400" boxSize={3} />
                                    <Text fontSize="sm" color={colorMode === 'light' ? 'gray.600' : 'gray.300'}>
                                        {feature}
                                    </Text>
                                </HStack>
                            ))}
                        </VStack>

                        <Button
                            borderRadius="md"
                            variant="solid"
                            colorScheme="blue"
                            width="full"
                            onClick={handleGoPay}
                        >
                            Upgrade Now
                        </Button>

                        <Button
                            borderRadius="md"
                            variant="outline"
                            colorScheme="blue"
                            width="full"
                            isLoading={loading}
                            onClick={handleGoHome}
                        >
                            Not Yet
                        </Button>

                    </Stack>
                </Box>
            </Stack>
        </Flex>
    );
};

// Payment Page Wrapper (loads Stripe)
const AskPayment = ({promptPayment, setPromptPayment}) => (
    <AskPaymentCard promptPayment={promptPayment} setPromptPayment={setPromptPayment}/>
);


export default AskPayment;